// add the recaptcha challenge container and the DataGrail consent banner as shards so they are clickable when a modal is open
export const getModalShards = () => {
  if (typeof document === 'undefined') return [];

  const recaptchaContainer = document.querySelector('.recaptcha-challenge-container')?.parentNode;
  const datagrailBanner = document.querySelector('.dg-consent-banner');

  return [recaptchaContainer, datagrailBanner].filter(Boolean) as HTMLElement[];
};
